import store from '../../store';

export default ({ next }) => {
    if (!store.getters.isUserAuthenticated) {
        next();
    } else {
        next('/');
    }
}
